import { FC, Fragment } from 'react';
import { CustomerLocationsModal } from 'pages/Settings/pages/LocationSettings/CustomersSettingsPage/modal/CustomerLocationsModal';
import {
  AddNewCustomerButton,
  CustomersSettingsPageHeader,
} from 'pages/Settings/pages/LocationSettings/CustomersSettingsPage/components';
import {
  CustomerSettingsBodyCell,
  CustomerSettingsBodyCellLayout,
  CustomerSettingsHeaderCell,
  CustomerSettingsHeaderCellLayout,
  CustomerSettingsHeaderRow,
  CustomerSettingsTableRow,
  EditCustomerLink,
  LocationsCount,
} from 'pages/Settings/pages/LocationSettings/CustomersSettingsPage/CustomersSettingsPage.styled';
import { Flex } from 'components/Flex';
import { useCustomersSettingsPageDataContext } from 'pages/Settings/pages/LocationSettings/CustomersSettingsPage/CustomersSettingsPage.data.context';
import { useTranslation } from 'hooks/useTranslation';
import { useHistory, useParams } from 'react-router-dom';
import { customerLocationsModalRoutingService } from 'pages/Settings/pages/LocationSettings/CustomersSettingsPage/modal';

const CustomersSettingsTableView: FC = () => {
  const { data } = useCustomersSettingsPageDataContext();
  const { t } = useTranslation();
  const { locationId } = useParams<{ locationId: string }>();
  const history = useHistory();

  const handleEditCustomer = (customerId: number) => {
    history.push(`/settings/locations/${locationId}/customers/${customerId}/edit`);
  };

  const handleLocationsClick = (customerId: number) => {
    customerLocationsModalRoutingService.open(
      { customerId: customerId.toString() },
      'CustomerLocationsView',
    );
  };
  return (
    <Fragment>
      <CustomersSettingsPageHeader />
      <Flex padding="20px 0 0 0" />
      <CustomerSettingsHeaderRow>
        <CustomerSettingsHeaderCellLayout width="calc(100% - 400px)" minWidth="200px">
          <CustomerSettingsHeaderCell data-cy="lbl-customers-read">
            {t('location_settings:CUSTOMERS')}
          </CustomerSettingsHeaderCell>
        </CustomerSettingsHeaderCellLayout>
        <CustomerSettingsHeaderCellLayout width="400px">
          <CustomerSettingsHeaderCell>
            {t('location_settings:LOCATIONS_HEADER')}
          </CustomerSettingsHeaderCell>
        </CustomerSettingsHeaderCellLayout>
        <CustomerSettingsHeaderCellLayout width="200px">
          <CustomerSettingsHeaderCell>{t('location_settings:ACTIONS')}</CustomerSettingsHeaderCell>
        </CustomerSettingsHeaderCellLayout>
      </CustomerSettingsHeaderRow>

      {data?.fetchCommunity?.subFacilities?.map((customer, index) => {
        const isGrey = !(index % 2);
        const locationsCount = customer.subFacilityAddresses?.length || 0;

        return (
          <CustomerSettingsTableRow key={customer.displayId} $isGrey={isGrey}>
            <CustomerSettingsBodyCellLayout width="calc(100% - 400px)" minWidth="200px">
              <CustomerSettingsBodyCell data-cy="read-customer-name">
                {customer.name}
              </CustomerSettingsBodyCell>
            </CustomerSettingsBodyCellLayout>
            <Flex width="400px" padding="12px 16px 12px 50px">
              <CustomerSettingsBodyCell>
                <LocationsCount
                  onClick={() => handleLocationsClick(Number(customer.displayId))}
                  data-cy="locations-count"
                >
                  {locationsCount}
                </LocationsCount>
              </CustomerSettingsBodyCell>
            </Flex>
            <CustomerSettingsBodyCellLayout width="200px">
              <CustomerSettingsBodyCell>
                <EditCustomerLink
                  onClick={() => handleEditCustomer(Number(customer.displayId))}
                  data-cy="btn-edit-customer"
                >
                  {t('location_settings:EDIT')}
                </EditCustomerLink>
              </CustomerSettingsBodyCell>
            </CustomerSettingsBodyCellLayout>
          </CustomerSettingsTableRow>
        );
      })}
      <AddNewCustomerButton />
    </Fragment>
  );
};

export const ReadView: FC = () => {
  return (
    <Fragment>
      <CustomersSettingsTableView />
      <CustomerLocationsModal />
    </Fragment>
  );
};
